import React from 'react';
import {
  PersonalInformation,
  AiSummary,
  UpdatePassword,
  DangerZone,
  ProductTour,
} from '../components/settings';

export const renderTabContent = (activeTab: string) => {
  switch (activeTab) {
    case 'personal-information':
      return <PersonalInformation />;
    // Jun-18 (a user V1 test, P4 follow-up): the 'message-template' tab nav was
    // hidden Jun-16, but this route case still rendered the AI-outreach template
    // editor when reached by direct URL (?tab=message-template). Removed so the
    // AI-to-AI message-template editor is no longer reachable at all. The nav
    // entry stays commented out in lib/constants.tsx settingsTabs.
    case 'ai-summary':
      return <AiSummary />;
    case 'update-password':
      return <UpdatePassword />;
    case 'product-tour':
      return <ProductTour />;
    case 'delete-account':
      return <DangerZone />;
    default:
      return null;
  }
};
